
import PropTypes from 'prop-types';
import _ from 'lodash';
import qs from 'qs';
import axios from 'axios';
import localForage from 'localforage';
import React, { Component } from 'react';


export function withAsync(WrappedComponent) {
  return class extends Component {

    static propTypes = {
      url: PropTypes.string.isRequired,
      useCache: PropTypes.bool,
      timeout: PropTypes.number,
      defaultOptions: PropTypes.array
    };

    static defaultProps = {
      useCache: false,
      timeout: 1,
      defaultOptions: []
    };

    constructor(props) {
      super(props);

      this.state = {
        options: [],
        filter: this.props.filter,
        loading: true
      }
    }

    componentDidMount() {
      this.loadAllOptions();
    }

    // eslint-disable-next-line
    componentWillReceiveProps(nextProps, nextContext) {
      if (!_.isEqual(nextProps.filter, this.state.filter)) {
        this.setState({filter: nextProps.filter}, () => {
          this.loadAllOptions();
        });
      }
    }

    getCachedKey = () => {
      const { url } = this.props;
      const { filter } = this.state;
      const queryString = new URLSearchParams(filter).toString();
      return `cached-options-${url}-${queryString}`;
    };

    getCachedOptions = async () => {
      const { useCache } = this.props;
      let options = [];
      if (useCache) {
        await localForage.getItem(this.getCachedKey()).then(value => {
          if (value) {
            try {
              const [ttl, cachedOptions] = value;
              if (ttl < Date.now()) {
                localForage.removeItem(this.getCachedKey());
              } else if (_.isArray(cachedOptions)) {
                options = cachedOptions;
              }
            } catch (e) {
              localForage.removeItem(this.getCachedKey());
            }
          }
        });
      }

      return options;
    };

    setCachedOptions = (options) => {
      const { useCache, timeout } = this.props;
      if (useCache) {
        localForage.setItem(this.getCachedKey(), [Date.now() + (timeout * 60 * 1000), options]);
      }
    };

    handleLoaded = () => {
      const { onLoaded, value } = this.props;
      const { options } = this.state;
      if (onLoaded) {
        if (value) {
          onLoaded(options.find(o => o.id === value));
        }
      }
    };

    handleAddOption = (option, isSelect) => {
      let { options } = this.state;
      if (option) {
        options.unshift(option);

        this.setState({
          options: options
        })
      }
    };

    loadAllOptions = async () => {
      const { filter } = this.state;
      const { url, defaultOptions } = this.props;
      let options = await this.getCachedOptions();
      if (options.length === 0) {
        const load = async (page) => {
          return axios.get(url, {
            params: {page: page, ...filter},
            paramsSerializer: function (params) {
              return qs.stringify(params, {arrayFormat: 'repeat'})
            },
          }).then(res => {
            const data = res.data;
            if (data) {
              if (data.results && data.results.length > 0) {
                options = options.concat(data.results);
              }
              if (data.pagination && data.pagination.next) {
                return load(data.pagination.next);
              }
            }
          });
        };

        await load(1);

        this.setCachedOptions(options);
      }

      if (defaultOptions.length > 0) {
        options = defaultOptions.concat(options);
      }

      this.setState({
        loading: false,
        options: options
      }, () => this.handleLoaded());
    };

    render() {
      const { options, loading } = this.state;
      const { url, useCache, timeout, filter, defaultOptions, onLoaded, ...otherProps } = this.props;
      return (
        <WrappedComponent
          options={options}
          loading={loading}
          optionValue={'id'}
          onAddOption={this.handleAddOption}
          {...otherProps}
        />
      )
    }
  }
}
